module.exports = __webpack_public_path__ + "img/story8-Bluehwald.jpg";